import { useLocation } from "react-router-dom";
import SEO from "@/components/SEO";

// Per-route SEO metadata. Keys are exact paths or prefixes (longest-match wins).
const META = {
  "/": {
    title: null, // use default site title
    description:
      "KhojByte Research Lab — Nepal's modern research publication consultation. Idea-to-publication workflow tracking, AI-assisted mentor matching, journal & conference database, surveys, LMS, and researcher portfolios.",
  },
  "/about": {
    title: "About",
    description: "Meet KhojByte Research Lab — a Nepal-based research publication consultation and innovation organization based in Kirtipur, Kathmandu.",
  },
  "/services": {
    title: "Services",
    description: "Publication consultation, thesis mentorship, academic writing support, AI & digital research training, institutional collaboration, workshops and bootcamps.",
  },
  "/publications": {
    title: "Published Papers",
    description: "Browse research papers published by mentors, mentees and partners of KhojByte Research Lab.",
  },
  "/research-ideas": {
    title: "Research Ideas",
    description: "Curated, ready-to-execute research ideas across domains — perfect starting points for thesis, dissertation, or publication.",
  },
  "/datasets": {
    title: "Research Datasets",
    description: "Open and premium research datasets curated by KhojByte for thesis, papers, and applied research.",
  },
  "/explainers": {
    title: "Paper Explainers",
    description: "Plain-language explainers of complex research papers — perfect for students and curious researchers.",
  },
  "/blogs": {
    title: "Journal — Field Notes & Essays",
    description: "Essays, deep-dives, and field notes from KhojByte Research Lab — on methodology, publication, and applied research.",
  },
  "/journals": {
    title: "Journals & Conferences Database",
    description: "Searchable database of publication venues — quartile, impact factor, APC, indexing and submission URLs — curated by KhojByte.",
  },
  "/discussions": {
    title: "Research Discussions",
    description: "Threaded discussions, Q&A, and conversations between researchers, mentors, and students.",
  },
  "/events": {
    title: "Webinars, Workshops & Events",
    description: "Live and upcoming research webinars, training workshops and conferences hosted by KhojByte Research Lab.",
  },
  "/pricing": {
    title: "Pricing & Subscription Plans",
    description: "Transparent pricing for KhojByte services — publication consultation, mentorship, LMS, and premium research content.",
  },
  "/login": { title: "Sign In", description: "Sign in to your KhojByte Research Lab account." },
  "/register": { title: "Create Account", description: "Join KhojByte Research Lab — submit your first research idea or request a mentor." },
  "/privacy": {
    title: "Privacy Policy",
    description: "KhojByte Research Lab's privacy policy — what data we collect, how we use it, and your rights as a researcher.",
  },
  "/team": {
    title: "The Team",
    description: "Meet the researchers, mentors and engineers behind KhojByte Research Lab — Nepal's research publication operating system.",
  },
  "/project-to-paper": {
    title: "Project to Paper",
    description: "Turn your class project, internship report or unfinished thesis into a peer-reviewed, indexed research paper — guided by KhojByte mentors.",
  },
  "/faq": {
    title: "FAQ",
    description: "Frequently asked questions about KhojByte's research workflow, mentorship programs, LMS courses, pricing and privacy.",
  },
};

function matchMeta(pathname) {
  if (META[pathname]) return META[pathname];
  // Longest-prefix match (e.g. /publications/:id falls back to /publications)
  let best = null;
  for (const key of Object.keys(META)) {
    if (key !== "/" && pathname.startsWith(key + "/")) {
      if (!best || key.length > best.length) best = key;
    }
  }
  return best ? META[best] : META["/"];
}

export default function RouteSEO() {
  const { pathname } = useLocation();
  const meta = matchMeta(pathname);
  return <SEO title={meta.title} description={meta.description} path={pathname} />;
}
